export * from './main-page/main-page.component';
export * from './resources-page/resources-page.component';
